import Config from './Config.jsx';

export default Config;


// WEBPACK FOOTER //
// ./src/components/Config/index.jsx